import { render, staticRenderFns } from "./PMSSetting.vue?vue&type=template&id=0f413a24&scoped=true&"
import script from "./PMSSetting.vue?vue&type=script&lang=ts&"
export * from "./PMSSetting.vue?vue&type=script&lang=ts&"
import style0 from "./PMSSetting.vue?vue&type=style&index=0&id=0f413a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f413a24",
  null
  
)

export default component.exports